import type { TestMultipleChoiceSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outlineStyles } from 'components/Editor/styled/Outline'
import { border } from 'services/Branding/common.styled'
import type { ElementStyleCss } from 'services/Branding/types'

import MarkStyled from './MarkStyled'

const CheckboxStyled = styled.label<{
  $styles: ElementStyleCss<TestMultipleChoiceSchemaType>
  $disabled?: boolean
}>`
  position: relative;
  display: flex;
  max-width: 100%;
  align-items: center;
  cursor: pointer;
  user-select: none;
  overflow: hidden;

  input {
    top: 0;
    left: 0;
    position: absolute;
    width: 0;
    height: 0;
    cursor: pointer;
    opacity: 0;
  }
  box-shadow: ${({ $styles }) => $styles?.effects?.boxShadow};
  padding: ${({ $styles }) => $styles.text.padding};
  ${({ $styles }) => border($styles.border)}
  background-color: ${({ $styles }) => $styles?.item?.backgroundColor};

  &:hover {
    background-color: ${({ $styles }) => $styles.item_hover.backgroundColor};
  }

  &:hover ${MarkStyled} {
    border-color: ${({ $disabled, $styles }) => !$disabled && $styles?.checkbox?.color};
  }

  &:has(input:focus-visible) {
    ${outlineStyles}

    background-color: ${({ $styles }) => $styles.item_hover.backgroundColor};

    & ${MarkStyled} {
      border-color: ${({ $styles }) => $styles?.checkbox?.color};
    }
  }
`

export default CheckboxStyled
